import "@/App.css";
import SmoothScroll from "@/components/SmoothScroll";
import StickyCta from "@/components/StickyCta";
import CookieConsent from "@/components/CookieConsent";
import Hero from "@/components/sections/Hero";
import Banner from "@/components/sections/Banner";
import Problem from "@/components/sections/Problem";
import Identification from "@/components/sections/Identification";
import Promise from "@/components/sections/Promise";
import Passages from "@/components/sections/Passages";
import BetweenEvenings from "@/components/sections/BetweenEvenings";
import Dolphins from "@/components/sections/Dolphins";
import Pact from "@/components/sections/Pact";
import Gilles from "@/components/sections/Gilles";
import Reassurance from "@/components/sections/Reassurance";
import Faq from "@/components/sections/Faq";
import FinalCta from "@/components/sections/FinalCta";
import Footer from "@/components/sections/Footer";

function App() {
  return (
    <div className="App">
      <SmoothScroll />
      <main>
        <Hero />
        <Banner />
        <Problem />
        <Identification />
        <Promise />
        <Passages />
        <BetweenEvenings />
        <Dolphins />
        <Pact />
        <Gilles />
        <Reassurance />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <StickyCta />
      <CookieConsent />
    </div>
  );
}

export default App;
